module.exports = {
      id: "protocol-usage",
      viewBox: "0 0 34 32",
      url: __webpack_public_path__ + "assets/img/sprite-6589e8.svg#protocol-usage",
      toString: function () {
        return this.url;
      }
    }